import React from 'react'
import { useTranslation } from 'react-i18next'
import { Container } from 'react-bootstrap'
import { useParams } from 'react-router'
import Avatar from 'design-system/avatar'
import { AvatarSizes } from 'design-system/avatar/src/resources/Avatar.enum'
import styles from './UserData.module.scss'
import { ILmsProfileModel } from 'models/lmsProfile.model'
import Tag from 'components/ui/tag/Tag'
import Button from 'design-system/button'
import { ButtonSizes } from 'design-system/button/src/Button'
import { useSelector } from 'react-redux'
import { IMainState } from 'store/states'
import { IUserMonitoringModel } from 'models/monitoring.model'

interface IUserData {
  data: IUserMonitoringModel
}

interface Params {
  userId: string
}

export const UserData: React.FC<IUserData> = ({ data }) => {
  const { t } = useTranslation()
  const { userId } = useParams<Params>()
  const generateLmsProfiles = (lmsProfiles: any[]) => {
    const { manuallyAssigned } = data
    if (lmsProfiles && (lmsProfiles.length || !manuallyAssigned)) {
      return (
        lmsProfiles &&
        lmsProfiles.map((profile: ILmsProfileModel) => {
          return (
            <Tag
              key={profile.name + '+' + profile.color}
              text={profile.name}
              color={profile.color}
              size={'sm'}
            />
          )
        })
      )
    }

    if(manuallyAssigned){
      return (
        <Tag
          key={'manuallyAssigned'}
          text={'Asignado manualmente'}
          color={''}
          size={'sm'}
        />
      )
    }
  }
  const { permission } = useSelector(({ user }: IMainState) => user)
  const area = data.enterprise?.area
  return (
    <Container fluid className="mr-2">
      <div>
        <Avatar
          sizes={AvatarSizes.XExtraLarge}
          className={styles.avatar}
          src={data.avatar}
        />
        <h1 className={styles.name}>{`${data.name} ${data.lastname}`}</h1>
        {area && (
          <div className="mb-2">
            <h2 className={styles.area}>{area.name}</h2>
          </div>
        )}
        <div>
          <h3 className={styles.positionIdentifierEmail}>
            {data.enterprise && data.enterprise.position}
          </h3>
          <h3 className={`${styles.positionIdentifierEmail}`}>
            {data.identifier}
          </h3>
          <h3 className={`${styles.positionIdentifierEmail} mb-5`}>
            {data.email}
          </h3>
          {data.course && data.course.lmsProfiles && (
            <>
              <h2 className={styles.lmsProfile}>
                {t('administration.monitor.participantResults.lmsProfiles')}
              </h2>
              <div>{generateLmsProfiles(data.course.lmsProfiles)}</div>
            </>
          )}
        </div>
        {(permission.admin || permission.supervisor) && (
          <div className="mt-3">
            <Button
              className="m-0"
              size={ButtonSizes.Small}
              onClick={() => window.open(`/configuration/user/${userId}`)}
              component="a"
            >
              {t('administration.monitor.participantResults.seeParticipant')}
            </Button>
          </div>
        )}
      </div>
    </Container>
  )
}

export default UserData
